import {
  BadgeDollarSign, BarChart3, Banknote, Bell, BookOpen, Briefcase, Building, Building2, Calculator, CalendarClock, CalendarDays, ChartLine, ChartPie,
  CircleDollarSign, ClipboardList, Coins, CreditCard, FileBarChart, FileSignature, FileText, Flag, FolderOpen, Gauge, Handshake, House,
  KeyRound, Landmark, LayoutDashboard, LayoutGrid, Map, MapPin, PiggyBank, ReceiptText, Settings2, ShieldCheck, ShoppingBasket, Sparkles, Star,
  Store, Tags, Target, TrendingUp, Trophy, UserRound, Users, UsersRound, Wallet, WalletCards,
} from "lucide-react";

export const ICONS = {
  LayoutDashboard, LayoutGrid, Gauge, House, Building, Building2, Store, Landmark, KeyRound, MapPin, Map, Handshake, FileSignature, FileText,
  FileBarChart, ClipboardList, FolderOpen, BookOpen, ReceiptText, Wallet, WalletCards, CreditCard, Banknote, Coins, CircleDollarSign, BadgeDollarSign,
  PiggyBank, Calculator, BarChart3, ChartLine, ChartPie, TrendingUp, Target, Trophy, Flag, Star, CalendarClock, CalendarDays, Bell, Users, UsersRound,
  UserRound, Briefcase, ShoppingBasket, Tags, ShieldCheck, Sparkles, Settings2,
};

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function MenuIcon({ id, item, fallback: Fallback, size = 18 }) {
  if (item?.icon_version) return <img className="menu-icon-img" src={`${API}/appearance/icon/${id}?v=${item.icon_version}`} alt="" width={size} height={size} />;
  const Icon = ICONS[item?.icon] || Fallback;
  return <Icon size={size} />;
}

const hex = (c) => [1, 3, 5].map((i) => parseInt(c.slice(i, i + 2), 16));
const mix = (c, w) => `#${hex(c).map((v) => Math.round(v + (255 - v) * w).toString(16).padStart(2, "0")).join("")}`;

export function applyTypography(font, size) {
  const d = document.documentElement.dataset;
  d.font = font || "rajdhani"; d.size = size || "md";
}

export function applyTheme(color) {
  const root = document.documentElement.style;
  if (!color) { ["--blue", "--btn", "--blue-soft", "--blue-border"].forEach((k) => root.removeProperty(k)); return; }
  root.setProperty("--blue", color); root.setProperty("--btn", color);
  root.setProperty("--blue-soft", mix(color, 0.9)); root.setProperty("--blue-border", mix(color, 0.78));
}
